import styled from 'styled-components';
import { fading } from '../../theme/animations';

const formatCssSize = (value?: string | number) => (typeof value === 'number' ? `${value}px` : value || 'auto');

export const StyledDropdownMenuContainer = styled.ul<{
    isVisible: boolean;
    bottom: number | string;
    left?: number | string;
    right?: number | string;
    maxWidth?: string;
    width?: string;
}>`
    box-sizing: border-box;
    max-width: ${props => props.maxWidth || 'none'};
    width: ${props => props.width || 'auto'};
    padding: 8px 0;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.24) 0 16px 24px;
    margin: 10px 0 0 0;
    background: ${props => props.theme.root.colors.background['02Second']};
    border-radius: 8px;
    display: ${props => (props.isVisible ? 'flex' : 'none')};
    list-style: none;
    position: absolute;
    z-index: 10;
    bottom: ${props => formatCssSize(props.bottom)};
    left: ${props => formatCssSize(props.left)};
    right: ${props => formatCssSize(props.right)};
    ${fading}
`;

export const StyledDropdownContainer = styled.div<{
    isVisible: boolean;
    top: number | string;
    left: number | string;
    maxWidth?: string;
    width?: string;
}>`
    box-sizing: border-box;
    max-width: 400px;
    width: 100%;
    max-width: ${props => props.width || 'none'};
    width: ${props => props.width || 'auto'};
    padding: 8px;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.24) 0 16px 24px;
    margin: 10px 0 0 0;
    background: ${props => props.theme.root.colors.background['02Second']};
    border-radius: 8px;
    visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
    display: flex;
    position: absolute;
    z-index: 10;
    top: ${props => formatCssSize(props.top)};
    left: ${props => formatCssSize(props.left)};
`;
